import React from 'react';
import { toRound } from '../../../helpers/Format';
import Text from '../../../elements/Text';
import { T } from '../../../helpers/i18n';
import { BlockSeparator } from './BlockSeparator';
export const BlockExtras = ({ item }) => {
    if (item.extraLines && item.extraLines.length > 0) {
        return (React.createElement("div", { style: { width: '100%', paddingLeft: '10px', paddingRight: '10px' } },
            React.createElement(Text, { big: true, style: { textDecoration: 'underline' } }, T('extras')),
            item.extraLines.map(line => React.createElement("div", { key: 'div ' + line.extraName },
                React.createElement("div", { key: line.extraName, style: {
                        // width: '100%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                    } },
                    React.createElement("p", { style: { flex: 1, marginBottom: 0 } }, `${line.quantity}x`),
                    React.createElement("p", { style: { flex: 8, marginBottom: 0 } }, line.extraName),
                    React.createElement("p", { style: { textAlign: 'end', marginBottom: 0 } }, toRound(line.total))),
                !line.printDescription &&
                    React.createElement("p", { style: { paddingLeft: '15px', marginTop: 0, marginBottom: 10 }, key: 'p' + line.extraName }, line.description))),
            React.createElement(BlockSeparator, null)));
    }
    return null;
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockExtras.tsx
// module id = 526
// module chunks = 0